var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { commonService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { Service } from "~/core/service";
import { FilterService } from "~/utils/filter.service";
var CaseRecodingService = /** @class */ (function (_super) {
    __extends(CaseRecodingService, _super);
    function CaseRecodingService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *录音导出
     */
    CaseRecodingService.prototype.downloadRecodingPackage = function (data, loading) {
        return this.netService.send({
            server: commonService.caseRecodingController.downloadRecodingPackage,
            data: {
                principalId: data.principalId,
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                certificateNo: data.certificateNo,
                account: data.account,
                cardNo: data.cardNo,
                delegationDate1: FilterService.dateRanageFormat(data.delegationDate, 'yyyy-MM-dd').start,
                delegationDate2: FilterService.dateRanageFormat(data.delegationDate, 'yyyy-MM-dd').end,
                endCaseDate1: FilterService.dateRanageFormat(data.caseDate, 'yyyy-MM-dd').start,
                endCaseDate2: FilterService.dateRanageFormat(data.caseDate, 'yyyy-MM-dd').end,
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseRecodingService.prototype, "netService", void 0);
    return CaseRecodingService;
}(Service));
export { CaseRecodingService };
